import React, { Component, ChangeEvent } from 'react';
import { RouteComponentProps } from "react-router";
import { withRouter } from "react-router";
import { Container, NavItem, NavLink, Col, Row, Nav, TabContent, TabPane, UncontrolledPopover, PopoverBody, Spinner, UncontrolledTooltip } from 'reactstrap';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';



import Collapse from "@kunukn/react-collapse";

import { env } from './env';


import * as KSLPlusAPI from "./services/KSLPlusAPI"
import { Login } from './components/LoginComp';
import { ForgotPW } from './components/ForgotPWComp';


import { CommentBox } from './components/CommentBoxComp';
import { MessageBox } from './components/MessageBoxComp';
import { Dokumente } from './components/DokumentenComp';
import { Vorbericht } from './components/VorberichtComp';
import { Finanzdaten } from './components/FinanzdatenComp';
import { Planvergleich } from './components/PlanvergleichComp';
import { PlanvergleichDoppisch } from './components/PlanvergleichDoppischComp';
import { KennzahlenVergleich } from './components/KennzahlenVergleichComp';

import { VorberichtDoppisch } from './components/VorberichtDoppischComp';
import { FinanzdatenDoppisch } from './components/FinanzdatenDoppischComp';

import * as Utilities from "./components/Utilities"

import { MdExpandLess, MdExpandMore } from "react-icons/md";
import { TfiComment, TfiCommentAlt } from "react-icons/tfi";
import { LiaComment } from "react-icons/lia";
import { LuDownload } from "react-icons/lu";



import * as QueryString from "query-string";

import './custom.css'

type State = {
    activeTab: string,
    ready: boolean,
    selectedGLEbene: string;
    hauptTextActive: boolean;
    user: KSLPlusAPI.LoginResponse | undefined | null;
    token: string;
    logFailed: boolean;
    forgotPW: boolean;    
    userName: string;
    customerName: string | null;
    uhconfig: KSLPlusAPI.UhConfigModel | undefined;
    invalidURL: boolean;
    unauthorized: boolean;
    unauthorized4Comment: boolean;
    needsLogin: boolean;
    needsLogin4Comment: boolean;
    fullHeader: boolean;
    comment: boolean;
    vglKreis: number;
    vglKunde: number;
    vglKundenOptions: JSX.Element[];
    emptyKEVglAdmin: boolean;
    emptyKEVgl: boolean;
}


class App extends Component<RouteComponentProps> {
    static displayName = App.name;
        
        
    missingTabCount: number = 0;
    wappen: string;
    kunde: number;
    gemeinde: number;
    jahr: number;
    plantyp: number;
    planstufe: number;
    verwaltungsansicht: boolean;    
    psObject: KSLPlusAPI.Planstufen | null;
    hauptText: KSLPlusAPI.Texte|null;
    settings: KSLPlusAPI.SettingsModel|undefined;
    css: string|undefined;    
    massnahmen: KSLPlusAPI.Massnahman[] = [];
    uhconfigs: KSLPlusAPI.UhConfigModel[] = [];
    psVgl: KSLPlusAPI.Planstufen[] = [];
    kennzahlenVgl: boolean = false;
    keVglData: KSLPlusAPI.KennzahlenVergleichModel | null = null;

    constructor(props: any) {
        super(props);


        this.wappen = "";
        this.kunde = -1;
        this.gemeinde = -1;
        this.jahr = -1;
        this.plantyp = -1;
        this.planstufe = -1;
        this.verwaltungsansicht = false;
        this.kennzahlenVgl = false;
        this.psObject = null;
        this.hauptText = null;           

    }

    state: State = {
        activeTab: "1",
        ready: false,
        selectedGLEbene: "",
        hauptTextActive: false,
        user: null,  
        token: "",
        logFailed: false,
        forgotPW: false,        
        userName: "",
        customerName: "",
        uhconfig: undefined,
        invalidURL: false,
        unauthorized: false,
        unauthorized4Comment: false,
        needsLogin: false,        
        needsLogin4Comment: false,
        fullHeader: true,
        comment: false,
        vglKreis: -1,
        vglKunde: -1,
        vglKundenOptions: [],
        emptyKEVglAdmin: false,
        emptyKEVgl: false
    }

    componentDidMount() {
        this.parseParams();

        this.initApp();

        /*
        if (this.plantyp == 4) {
            this.refreshToken(true);
        }
        else
            this.readData();
        */
    }

    handleLogout = () => {
        localStorage.removeItem("KSLPlusAdmin_Token");
        localStorage.removeItem("KSLPlusAdmin_RefreshToken");
        this.setState({ unauthorized: false, user: undefined, logFailed: false, userName: "", token: "", ready: false });
    }

    handleLogin = (username: string, password: string) => {
        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";

        var request = new KSLPlusAPI.LoginModel();
        request.username = username;
        request.password = password;
        

        var client = new KSLPlusAPI.Authenticate_Client(api);
        client.login("", request).then(Response => {
            if (Response.roles && ((Response.roles.indexOf("Politiker") === -1 && Response.roles.indexOf("Admin") === -1 && Response.roles.indexOf("CustomerAdmin") === -1 && Response.roles.indexOf("CustomerUser") === -1 && Response.roles.indexOf("User") === -1) || (Response.roles.indexOf("Admin") === -1 && Response.customer === null))) {
                this.setState({ failed: true });
                return;
            }
            
            if (!Response.needNewPassword) {
                if (Response.token)
                    localStorage.setItem("KSLPlusAdmin_Token", Response.token);
                if (Response.refreshToken)
                    localStorage.setItem("KSLPlusAdmin_RefreshToken", Response.refreshToken);
            }            
            this.setState({ user: Response, logFailed: false, userName: username, customerName: Response.customerName, token: "Bearer " + Response.token });
            if (this.kennzahlenVgl)
                this.readKennzahlenVgl();
            else
                this.readData();

        }).catch(Reason => {
            //this.state.failed = true;
            this.setState({ logFailed: true });


        });
    };

    handleLogin4Comment = (username: string, password: string) => {
        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";

        var request = new KSLPlusAPI.LoginModel();
        request.username = username;
        request.password = password;


        var client = new KSLPlusAPI.Authenticate_Client(api);
        client.login("", request).then(Response => {
            if (Response.roles && ((Response.roles.indexOf("Politiker") === -1 && Response.roles.indexOf("Admin") === -1 && Response.roles.indexOf("CustomerAdmin") === -1 && Response.roles.indexOf("CustomerUser") === -1 && Response.roles.indexOf("User") === -1) || (Response.roles.indexOf("Admin") === -1 && Response.customer === null))) {
                this.setState({ failed: true });
                return;
            }            
            
            if (!Response.needNewPassword) {
                if (Response.token)
                    localStorage.setItem("KSLPlusAdmin_Token", Response.token);
                if (Response.refreshToken)
                    localStorage.setItem("KSLPlusAdmin_RefreshToken", Response.refreshToken);
            }
            this.state.user = Response;
            this.state.userName = username;
            this.state.customerName = Response?.customerName ?? "";            
            this.state.token = "Bearer " + Response.token;
            this.state.logFailed = false;            
        
            this.handleCommentKlick(true, false);

        }).catch(Reason => {
            //this.state.failed = true;
            this.setState({ logFailed: true });


        });
    };


    handleForgotPWClick = () => {
        this.setState({ forgotPW: true });
    };

    handleForgotPW = (username: string) => {
        this.setState({ forgotPW: false });

        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";


        var client = new KSLPlusAPI.Authenticate_Client(api);
        client.sendPasswordResetToken(username, "").then(Response => {
        }).catch(Reason => {

        });

    };


    refreshToken = async (useStorage: boolean = false, comment: boolean = false): Promise<KSLPlusAPI.LoginResponse | null> => {
                
        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";

        var request = new KSLPlusAPI.RefreshTokenModel();
        var username: null | string = null;
        if (!useStorage && this.state.user) {
            request.token = this.state.user.token;
            request.refreshToken = this.state.user.refreshToken;
        }
        else {            
            var remember = localStorage.getItem("KSLPlusAdmin_RememberMe");
            username = localStorage.getItem("KSLPlusAdmin_UserName");
            var token = localStorage.getItem("KSLPlusAdmin_Token");
            var refreshToken = localStorage.getItem("KSLPlusAdmin_RefreshToken");            
            if (remember !== "true" || username == null || token == null || refreshToken == null) {
                
                if (!comment) {
                    this.setState({ user: undefined, mounted: true });
                    this.handleLogout();
                }
                else {                    
                    this.handleCommentKlick(false, true);
                }
                return Promise.resolve<KSLPlusAPI.LoginResponse | null>(null);
            }

            request.token = token != null ? token : "";
            request.refreshToken = refreshToken != null ? refreshToken : "";            
        }



        var client = new KSLPlusAPI.Authenticate_Client(api);
        try {
            
            var Response = await client.refreshToken("", request);            
            if (Response.token)
                localStorage.setItem("KSLPlusAdmin_Token", Response.token);
            if (Response.refreshToken)
                localStorage.setItem("KSLPlusAdmin_RefreshToken", Response.refreshToken);
            
            this.state.token = "Bearer " + Response.token;
            this.state.logFailed = false;            
            this.state.user = Response;
            //this.state.userName = username != null ? username : "";
            this.state.userName = Response.userName ? Response.userName : "";
            this.state.customerName = Response.customerName ? Response.customerName : null;
            
            
            if (comment)
                this.handleCommentKlick(false, true);
            else if (this.kennzahlenVgl)
                this.readKennzahlenVgl();
            else
                this.readData();
            
            //this.state.user.token = Response.token;
            //this.state.user.refreshToken = Response.refreshToken;
            return Promise.resolve<KSLPlusAPI.LoginResponse | null>(Response);
        }
        catch (e) {
            if (!comment) {
                this.setState({ user: undefined, mounted: true });
                this.handleLogout();
            }
            else {
                this.handleCommentKlick(false, true);
            }            
        }
        
        return Promise.resolve<KSLPlusAPI.LoginResponse | null>(null);
    };
    

    readMassnahmen = () => {
        var request = new KSLPlusAPI.JahrModel();
        
        if (this.kunde === undefined)
            return;
        request.kunde = this.kunde;
        
        if (this.gemeinde === undefined)
            return;
        request.gemeinde = this.gemeinde;
        
        if (this.jahr === undefined)
            return;
        request.jahr = this.jahr;    
    
        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";

        var client = new KSLPlusAPI.DigitalHoushold_Client(api);
                

        client.getMassnahmen("", request).then(mns => {
            this.massnahmen = mns;            
        }).catch(Reason => {
            this.massnahmen = [];
        });
    }

    parseParams = () => {
        const { location } = this.props;
        const params = QueryString.parse(location.search);

        if (params.css != null) {
            if (Array.isArray(params.css))
                this.css = params.css[0];
            else
                this.css = params.css;
        }

        if (params.kunde != null) {
            if (Array.isArray(params.kunde))
                this.kunde = +params.kunde[0];
            else
                this.kunde = +params.kunde;
        }
        if (params.gemeinde != null) {
            if (Array.isArray(params.gemeinde))
                this.gemeinde = +params.gemeinde[0];
            else
                this.gemeinde = +params.gemeinde;
        }
        if (params.jahr != null) {
            if (Array.isArray(params.jahr))
                this.jahr = +params.jahr[0];
            else
                this.jahr = +params.jahr;
        }
        if (params.plantyp != null) {
            if (Array.isArray(params.plantyp))
                this.plantyp = +params.plantyp[0];
            else
                this.plantyp = +params.plantyp;
        }
        if (params.planstufe != null) {
            if (Array.isArray(params.planstufe))
                this.planstufe = +params.planstufe[0];
            else
                this.planstufe = +params.planstufe;
        }
        if (params.verwaltung != null) {
            if (Array.isArray(params.verwaltung))
                this.verwaltungsansicht = (+params.verwaltung[0] === 1);
            else
                this.verwaltungsansicht = (+params.verwaltung === 1);
        } 

        if (params.kennzahlenvgl != null) {
            if (Array.isArray(params.kennzahlenvgl))
                this.kennzahlenVgl = (+params.kennzahlenvgl[0] === 1);
            else
                this.kennzahlenVgl = (+params.kennzahlenvgl === 1);
        } 

        if (params.mt != null) {
            if (Array.isArray(params.mt))
                this.state.activeTab = params.mt[0];
            else
                this.state.activeTab = params.mt;
        } 

           
    }
    

    initApp = () => {


        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";
       
        var client = new KSLPlusAPI.DigitalHoushold_Client(api);        

        if (this.kennzahlenVgl) {
            this.refreshToken(true);
            this.setState({ needsLogin: true });
        }
        else {
            client.needsLogin(this.kunde, this.gemeinde, this.jahr, this.plantyp, this.planstufe, this.state.token).then(b => {
                if (b)
                    this.refreshToken(true);
                else
                    this.readData();
                this.setState({ needsLogin: b });
            }).catch(Reason => {
                this.setState({ invalidURL: true });
            });
        }
        
    }

    readKennzahlenVgl = () => {


        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";



        

        var client = new KSLPlusAPI.Kennzahlenvergleich_Client(api);
        
        client.getKennzahlenVergleich( this.jahr, this.state.vglKunde, this.state.token).then(keVglData => {

            this.keVglData = keVglData; 
            if ((keVglData.gemeindeKennzahlen?.length ?? 0) === 0) {
                if (this.state.user?.roles?.indexOf("Admin") !== -1)
                    this.setState({ emptyKEVglAdmin: true });
                else
                    this.setState({ emptyKEVgl: true });
            }
            if (keVglData.vergleichskreise && keVglData.vergleichskreise.length)
                this.state.vglKreis = keVglData.vergleichskreise[0].id ?? 0;

            if (this.state.vglKunde === -1)
                this.setState({vglKundenOptions: this.getVglKundenOptions()} )
            this.setState({ ready: true })
        }).catch(Reason => {
            alert(Reason.message);
            if (Reason.status === 401)
                this.setState({ unauthorized: true });
            else
                this.setState({ invalidURL: true });
        });

        



    }

    handleExportKennzahlenVgl = () => {


        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";





        var client = new KSLPlusAPI.Kennzahlenvergleich_Client(api);
        if (!this.keVglData?.userSettings || !this.keVglData?.userSettings[this.state.vglKreis])
            return;

        client.exportKennzahlenVergleich(this.jahr, this.state.vglKunde, this.state.vglKreis, this.state.token, this.keVglData?.userSettings[this.state.vglKreis]).then(file => {            
            var downloadLink = document.createElement("a");
            downloadLink.href = window.URL.createObjectURL(file.data);
            downloadLink.download = file.fileName ? file.fileName : "Kennzahlenvergleich.xlsx";

            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            this.setState({ wait: false })
        }).catch(Reason => {
            alert(Reason.message);
            
        });





    }

    getVglKreisOptions = () => {
        var items = Object.keys(this.keVglData?.vergleichskreise ?? []).map((key, index) => {
            const vk = (this.keVglData?.vergleichskreise ?? [])[key as any];

            return (
                <option value={vk.id}>{vk.id + " - " + vk.bezeichnung + (((vk?.id ?? 0) > 9999 && (vk?.id ?? 0) < 20000) ? (vk.bundesland ? " (" + vk.bundesland + ")" : " (bundesweit)") : "")}</option>
            );
        });
        return items;
    }


    getVglKundenOptions = () => {
        var items = Object.keys(this.keVglData?.kunden ?? []).map((key, index) => {
            const k = (this.keVglData?.kunden ?? [])[key as any];

            return (
                <option value={k.kunde}>{k.name}</option>
            );
        });
        items.unshift(<option value={-1}>Alle Kunden</option>)
        return items;
    }


    readData = () => {
        
        
        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";
        
        
        
        // custom.css installieren, fall angegeben
        if ( this.css )
        {            
            var p;
            var tl = document.getElementsByTagName("link")[0]
            if (tl) 
                    p = tl.parentNode; 
            else 
                    p = document.getElementsByTagName('head')[0];
            var c = document.createElement("link");
            c.href = env.REACT_APP_PUBLIC_URL + "css/" + this.css;     
            c.href += "?" + Math.random();         
            c.rel = "stylesheet";
            
            if ( p )            
                p.appendChild(c);                                                   
        }

        


        

        var client = new KSLPlusAPI.DigitalHoushold_Client(api);

        // css lesen
        client.texte(this.kunde, this.gemeinde, this.jahr, 3, "").then(t => { 
            if ( t != null && t.length > 0 && t[0].text && t[0].text.length > 0 )
            {
                var head = document.head || document.getElementsByTagName('head')[0];
                var style = document.createElement('style');

                head.appendChild(style);

                style.type = 'text/css';                
                style.appendChild(document.createTextNode(t[0].text));                
            }  
            
        }).catch(Reason => {
        });
        
        client.bilder(this.kunde, this.gemeinde, this.jahr, 1, "").then(bilder => {            
            if (bilder.length > 0 && bilder[0].url !== undefined)
                this.wappen = bilder[0].url;
            this.setState({ready:true})
        }).catch(Reason => {            
        });

        client.planstufe(this.kunde, this.gemeinde, this.jahr, this.plantyp, this.planstufe, "").then(ps => {            
            this.psObject = ps;
            this.setState({ ready: true })
        }).catch(Reason => {            
        });

        client.texte(this.kunde, this.gemeinde, this.jahr, this.plantyp === 3 ? 5 : (this.plantyp === 4 ? 7 : 1), "").then(t => {            
            if (t != null && t.length > 0) {
                this.hauptText = t[0];
            }
            this.setState({ ready: true })
        }).catch(Reason => {
        });

                

        client.settings(this.kunde, this.gemeinde, this.jahr, this.plantyp, this.planstufe, this.plantyp === 3 ? 1 : (this.plantyp === 4 ? 2 : 0), this.verwaltungsansicht, this.state.token).then(s => {
            this.settings = s;

            // Gemeindename in Titel integrieren
            var head = document.head || document.getElementsByTagName('head')[0];
            var titles = head.getElementsByTagName('title');
            if (titles.length > 0)
                titles[0].innerText = "KSLplus - " + s.gemeindeName;

            if (this.plantyp < 3 && ((s.pvInBa && !this.verwaltungsansicht) || (s.pvInVa && this.verwaltungsansicht))) {
                client.getVglPlanstufen(this.kunde, this.gemeinde, this.jahr, !this.state.user, "").then(p => {                    
                    this.psVgl = p;
                    this.setState({ ready: true })
                }).catch(Reason => {
                });
            }   

            if (this.plantyp < 3 && s.pjFarbenFuerHover && window.document.styleSheets.length > 0) {
                let sheet = window.document.styleSheets[window.document.styleSheets.length - 1] as CSSStyleSheet;

                if  ( s.hFarbePJ )                
                    sheet.insertRule('.table-hover tbody .kslplus-row-sum-0:hover td, .table-hover tbody .kslplus-row-sum-0:hover th {  background-color: <color>; }'.replace("<color>", s.hFarbePJ), sheet.cssRules.length);

                if (s.hFarbePJ)
                    sheet.insertRule('.table-hover tbody .kslplus-row-sum-1:hover td, .table-hover tbody .kslplus-row-sum-1:hover th {  background-color: <color>; }'.replace("<color>", s.hFarbePJ), sheet.cssRules.length);

                if (s.hFarbeSumPJ)
                    sheet.insertRule('.table-hover tbody .kslplus-row-sum-2:hover td, .table-hover tbody .kslplus-row-sum-2:hover th {  background-color: <color>; }'.replace("<color>", s.hFarbeSumPJ), sheet.cssRules.length);
            }
            if (this.plantyp === 3 && s.jrFarbenFuerHover && window.document.styleSheets.length > 0) {
                let sheet = window.document.styleSheets[window.document.styleSheets.length - 1] as CSSStyleSheet;

                if (s.hFarbeJR)
                    sheet.insertRule('.table-hover tbody .kslplus-row-sum-0:hover td, .table-hover tbody .kslplus-row-sum-0:hover th {  background-color: <color>; }'.replace("<color>", s.hFarbeJR), sheet.cssRules.length);

                if (s.hFarbeJR)
                    sheet.insertRule('.table-hover tbody .kslplus-row-sum-1:hover td, .table-hover tbody .kslplus-row-sum-1:hover th {  background-color: <color>; }'.replace("<color>", s.hFarbeJR), sheet.cssRules.length);

                if (s.hFarbeSumJR)
                    sheet.insertRule('.table-hover tbody .kslplus-row-sum-2:hover td, .table-hover tbody .kslplus-row-sum-2:hover th {  background-color: <color>; }'.replace("<color>", s.hFarbeSumJR), sheet.cssRules.length);
            }

            if (s.buchungsart === 1)
                this.readMassnahmen();
                  

            this.setState({ ready: true })
        }).catch(Reason => {            
            if (Reason.status === 401)
                this.setState({ unauthorized: true });
            else 
                this.setState({ invalidURL: true });
        });

        //var clientAdmin = new KSLPlusAPI.DigitalHousholdAdmin_Client(api);        
        if (this.plantyp === 4) {
            client.getUHConfigs(this.kunde, this.gemeinde, this.jahr, "").then(c => {
                this.uhconfigs = c;
                if (c.length > 0)
                    this.setState({ uhconfig: c[0] });
                    
                this.setState({ ready: true })
            }).catch(Reason => {
            });
        }    

         

    }
   
    createTTItems = () => {
        var items: JSX.Element[] = [];
        
        if ( !this.settings || !this.settings.ttTexte)
            return items;
        
        var missing = false;
        var missingTabs = [];
        for (var i = 0; i < this.settings.ttTexte.length; i++) {                        
            var id = "kslplus-tab-" + this.settings.ttTexte[i].bezeichnung;            
            if ( document.querySelector("#" + id) )
            {                
                items.push(                
                    <UncontrolledPopover
                        size="lg"                        
                        placement="top"                        
                        target={id}
                        delay={ {show: 1000, hide: 0} }
                        trigger="hover"
                        key={"kslplus-menu-tooltip-" + i.toString()}
                        className="kslplus-menu-popover">
                        <PopoverBody className="kslplus-menu-popover-body">
                            {this.settings.ttTexte[i].text}                            
                        </PopoverBody>
                    </UncontrolledPopover> 
                );                  
            }            
            else 
            {                        
                missingTabs.push(this.settings.ttTexte[i].bezeichnung);
               missing = true;
            }
            
        }
        
        //<UncontrolledTooltip className="kslplus-menu-tooltip" placement="auto" delay={ {show: 1000, hide: 0} } target={id} key={"kslplus-menu-tooltip-" + i.toString()}>{this.settings.ttTexte[i].text}</UncontrolledTooltip>
          
        
        if (missing) {
            this.missingTabCount++;
            if ( this.missingTabCount < 10 )
                setTimeout(() => { this.setState({ ready: true }) }, 2000);
        }
            
        

        return items;
    }

    createUHConfigOptions = () => {

        var items: JSX.Element[] = [];
        this.uhconfigs.forEach((c) => {
            items.push(<option value={c.id}>{c.bezeichnung}</option>);
        });

        return items;
    }

    handleUHConfigChange(event: ChangeEvent<HTMLSelectElement>) {
        if (event.target != null) {
            var c = this.uhconfigs.find(c => c.id === +event.target.value);
           
            this.setState({ uhconfig: c })
        }
    }

    handleSubmitKommentar(betreff: string, text: string) {
        const api = env.REACT_APP_KSLPLUS_API || "https://localhost:5001";

        var client = new KSLPlusAPI.DigitalHousholdAdmin_Client(api);

        var komm = new KSLPlusAPI.Kommentare();
        komm.kunde = this.kunde;
        komm.gemeinde = this.gemeinde;
        komm.jahr = this.jahr;
        komm.plantyp = this.plantyp;
        komm.planstufe = this.planstufe;
        komm.userId = this.state.user?.userId;
        komm.betreff = betreff;
        komm.text = text;
        

        client.addKommentar(this.state.token, komm).then(e => {
            this.setState({ comment: false });            
        }).catch(Reason => {            
            if (Reason.status == 401) {
                this.refreshToken().then(Response => {
                    if (Response != null) {
                        return this.handleSubmitKommentar(betreff, text);
                    }
                    else {
                        this.setState({ comment: false });
                    }
                })
            }
            else {
                this.setState({ comment: false });
            }
        });
    }

    handleCommentKlick = (fromLogin: boolean = false, fromRefresh: boolean = false) => {
        if (this.state.user?.rechte && this.state.user?.rechte?.findIndex(s => s === "kommsend") !== -1 && (!this.state.customerName || this.state.customerName === this.settings?.kundeName))
        {            
            this.setState({ comment: true, needsLogin4Comment: false });
        }
        else {

            if (fromLogin) {                
                this.setState({ needsLogin4Comment: false, unauthorized4Comment: true });
            }
            else {
                if (!fromRefresh) {         
                    this.refreshToken(true, true);
                    
                }
                else if (!fromLogin) {                    
                    if (this.state.user?.rechte && this.state.user?.rechte?.findIndex(s => s === "kommsend") !== -1 && (!this.state.customerName || this.state.customerName === this.settings?.gemeindeName))
                        this.setState({ comment: true, needsLogin4Comment: false });
                    else
                        this.setState({ needsLogin4Comment: true });
                }
            }
        }

    }

    render() {        
        if (this.state.forgotPW) {
            return (
                <div className="auth-wrapper">
                    <div className="auth-inner">
                        <ForgotPW onSubmit={this.handleForgotPW} onGoBack={() => this.setState({ forgotPW: false })} />
                    </div>
                </div>);
        }
        else if (this.state.needsLogin && this.state.user === undefined) {
            return (
                <div className="auth-wrapper">
                    <div className="auth-inner">
                        <Login onSubmit={this.handleLogin} onForgotPW={this.handleForgotPWClick} failed={this.state.logFailed} />
                    </div>
                </div>);
        }                   

        if (this.state.invalidURL) {
            return (
                <MessageBox header="Fehler" text="Für die aufgerufenen URL liegen leider keine Daten vor!" open={this.state.invalidURL} b1="Weiterleiten zu KSLSoftwerk" onCancel={() => { window.location.href = "https://www.ksl-softwerk.de" }} onB1={() => { window.location.href = "https://www.ksl-softwerk.de" }} />
            );
        }

        if (this.state.emptyKEVgl) {
            return (
                <MessageBox header="Fehler" text="Der Kunden nimmt nicht am Kennzahlenvergleich teil oder es liegen keine freigegebenen Kennzahlen vor!" open={this.state.emptyKEVgl} b1="Weiterleiten zu KSLSoftwerk" onCancel={() => { window.location.href = "https://www.ksl-softwerk.de" }} onB1={() => { window.location.href = "https://www.ksl-softwerk.de" }} />
            );
        }

        if (this.state.emptyKEVglAdmin) {
            return (
                <MessageBox header="Fehler" text="Der Kunden nimmt nicht am Kennzahlenvergleich teil oder es liegen keine freigegebenen Kennzahlen vor!" open={this.state.emptyKEVglAdmin} b1="Schließen" onCancel={() => { this.setState({ emptyKEVglAdmin: false }) }} onB1={() => { this.setState({ emptyKEVglAdmin: false }) }} />
            );
        }

        if (this.state.unauthorized) {
            return (
                <MessageBox header="Fehler" text="Sie haben nicht die Berechtigung um auf diese URL zuzugreifen!" open={this.state.unauthorized} b1="Zurück zum Login" onCancel={this.handleLogout} onB1 = {this.handleLogout} />
            );
        }

        if ( this.kennzahlenVgl) {
            return <div className="kslplus-app-wrapper">
                <Container className="kslplus-app-container">
                    <div className="kslplus-headline">


                        <Row lg="14">
                            <div className="kslplus-headline-small">

                                <div id="kslplus-headline" className="kslplus-headline-kevgl ">{"Kennzahlenvergleich " + (this.keVglData?.jahr ?? "") + (this.keVglData ? " - " : "")}
                                    {this.keVglData &&
                                        <select className="kslplus-select-kevgl form-select" value={this.state.vglKreis} onChange={(e) => { this.setState({ vglKreis: +e.target?.value }) }}>
                                            {this.getVglKreisOptions()}
                                        </select>}
                                    {this.keVglData &&
                                        <>
                                            <LuDownload id="kslplus-downlod-kevgl" size={30} className="kslplus-comment-header" onClick={() => this.handleExportKennzahlenVgl()} />
                                            <UncontrolledTooltip
                                                delay={{ show: 2000, hide: 0 } }
                                                placement='bottom'
                                                target="kslplus-downlod-kevgl">
                                                Kennzahlen als Excel-Datei herunterladen
                                            </UncontrolledTooltip>
                                        </>}
                                    {this.state.user?.roles?.indexOf("Admin") !== -1 &&
                                        <select className="kslplus-select-kevgl kslplus-select-kevgl-kunde form-select" value={this.state.vglKunde} onChange={(e) => { this.state.vglKunde = +e.target?.value; this.keVglData = null;  this.setState({ vglKunde: +e.target?.value }); this.readKennzahlenVgl(); }}>
                                            {this.state.vglKundenOptions}
                                        </select>}
                                </div>          
                                
                            </div>
                            
                        </Row>                        

                    </div>
                    <Row>
                    <Col >
                        <div className="kslplus-haushaltstab-wrapper-top">
                            {this.keVglData ?
                                <KennzahlenVergleich keVglData={this.keVglData} vglKreis={this.state.vglKreis} token={this.state.token} kunde={this.state.user?.customer ?? this.state.vglKunde} /> :
                                <div className="d-flex justify-content-center"> <Spinner color="primary" /></div>

                            }
                        </div>
                        </Col>
                    </Row>
                </Container>
            </div>;
        }
            

        if (!this.state.ready || this.settings === undefined)
            return <div>Loading</div>;

        if (this.missingTabCount > 9)
            this.missingTabCount = 0;
        //var ttItems = this.createTTItems();
        var configOptions = this.createUHConfigOptions();

        var vbText = this.plantyp === 3 || this.plantyp === 4 ? "Vorschau" : "Vorbericht";
        var detailsText = this.plantyp === 3 || this.plantyp === 4 ? "Detailansicht" : "Finanzdaten";
        
        if (this.settings.tabTexte) {            
            let text = this.settings.tabTexte.find(t => t.bezeichnung === "vorberichtvorschau");
            if (text && text.text && text.text.length > 0)
                vbText = text.text;

            text = this.settings.tabTexte.find(t => t.bezeichnung === "finanzdatendetailansicht");
            if (text && text.text && text.text.length > 0)
                detailsText = text.text;
        }

        
        var ueberschrift = this.psObject?.ueberschrift ?? "";
        var showGN = ueberschrift === "";
        if ( ueberschrift === "" && this.plantyp < 3 )
            ueberschrift = this.settings && this.settings.doppelhaushalt ? ("Doppelhaushalt " + this.jahr + "/" + (this.jahr + 1).toString()) : ("Haushaltsplan " + this.jahr);
        else if (ueberschrift === "" && this.plantyp === 4)
            ueberschrift = this.settings && this.settings.doppelhaushalt ? ("Unterjähriges Berichtswesen " + this.jahr + "/" + (this.jahr + 1).toString()) : ("Unterjähriges Berichtswesen " + this.jahr);
        else if (ueberschrift === "" )
            ueberschrift = this.settings && this.settings.doppelhaushalt ? ("Jahresrechnung " + this.jahr + "/" + (this.jahr + 1).toString()) : ("Jahresrechnung " + this.jahr);
    
        return (
            <div className="kslplus-app-wrapper">
                <Container className="kslplus-app-container">
                    <div className="kslplus-headline">
                        
                        {this.state.fullHeader ?
                            <Row role="banner" lg="14">
                                <Col lg="4" className="kslplus-headline-wrapper-left">
                                    <div >
                                        
                                        
                                        <h1 id="kslplus-headline" className="kslplus-headline-main">{ueberschrift}
                                            {this.psObject && (this.psObject.kommentierbar ?? false) &&
                                                <LiaComment id="kslplus-comment" size={40} className="kslplus-comment-header" onClick={() => this.handleCommentKlick()} />
                                            }
                                            {this.psObject && (this.psObject.kommentierbar ?? false) &&
                                                <UncontrolledPopover
                                                    size="lg"
                                                    placement="right"
                                                    target="kslplus-comment"
                                                    delay={{ show: 1000, hide: 0 }}
                                                    trigger="hover"
                                                    className="kslplus-menu-popover">
                                                    <PopoverBody className="kslplus-menu-popover-body">
                                                        Kommentar zur Planstufe verfassen. Sie müssen dazu als Nutzer angemeldet sein.
                                                    </PopoverBody>
                                                </UncontrolledPopover>
                                            }
                                         </h1>
                                        
                                        
                                        
                                        {showGN && this.settings.gemeindeName ? <><h2 id="kslplus-headline" className="kslplus-headline-main">{this.settings.gemeindeName}</h2>

                                            <h3 id="kslplus-headline1" className="kslplus-headline-second">{this.psObject !== null ? this.psObject.bezeichnung : ""}</h3></> :
                                            <h2 id="kslplus-headline1" className="kslplus-headline-second">{this.psObject !== null ? this.psObject.bezeichnung : ""}</h2>}
                                    </div>
                                </Col>
                                <Col lg="4" className="kslplus-headline-wrapper-middle"><div ><div id="kslplus-wappen" >{this.wappen && <img className="kslplus-img-wappen" src={this.wappen} alt="Wappen" />}</div></div></Col>
                                <Col lg="4" className="kslplus-headline-wrapper-right">
                                    <div >
                                        <Dokumente modul={this.plantyp === 3 ? 1 : (this.plantyp === 4 ? 2 : 0)} kunde={this.kunde} gemeinde={this.gemeinde} jahr={this.jahr} />
                                    </div>
                                    
                                </Col>
                                <MdExpandMore size={50} className="kslplus-expand-header" onClick={() => this.setState({ fullHeader: false })} />
                            </Row> :
                            <Row role="banner" lg="14">
                                <div className="kslplus-headline-small">  
                                    
                                    <h1 id="kslplus-headline" className="kslplus-headline-main ">{ueberschrift}
                                        {this.psObject && (this.psObject.kommentierbar ?? false) &&                                             
                                            <LiaComment id="kslplus-comment" size={40} className="kslplus-comment-header" onClick={() => this.handleCommentKlick()} />                                            
                                        }
                                        {this.psObject && (this.psObject.kommentierbar ?? false) && 
                                            <UncontrolledPopover
                                                size="lg"
                                                placement="right"
                                                target="kslplus-comment"
                                                delay={{ show: 1000, hide: 0 }}
                                                trigger="hover"
                                                className="kslplus-menu-popover">
                                                <PopoverBody className="kslplus-menu-popover-body">
                                                    Kommentar zur Planstufe verfassen.  Sie müssen dazu als Nutzer angemeldet sein.
                                                </PopoverBody>
                                            </UncontrolledPopover>                                        
                                        }
                                    </h1>
                                    <MdExpandLess size={50} className="kslplus-expand-header" onClick={() => this.setState({ fullHeader: true })} />
                                    
                                </div>                                                                                                    
                            </Row>
                        }
                        
                        
                    </div>                    
                    
                    {(this.hauptText && this.hauptText.bezeichnung && this.hauptText.bezeichnung.length > 0) &&
                        <Row>
                            <Col className="kslplus-maintext-wrapper">
                                <button
                                    className={"kslplus-beschreibung-toggle" + (this.state.hauptTextActive ? " active" : "")}
                                    onClick={() => this.setState({ hauptTextActive: !this.state.hauptTextActive })}
                                >

                                    <span className="kslplus-beschreibung-text">{this.hauptText != null ? this.hauptText.bezeichnung : ""}</span>
                                    <div className="rotate90">
                                        <svg
                                            className={"kslplus-beschreibung-icon" + (this.state.hauptTextActive ? " expanded" : "")}
                                            viewBox="6 0 12 24"
                                        >
                                            <polygon points="8 0 6 1.8 14.4 12 6 22.2 8 24 18 12" />
                                        </svg>
                                    </div>

                                </button>
                                <Collapse
                                    isOpen={this.state.hauptTextActive}
                                    className={"kslplus-beschreibung-collapse-gradient " + (this.state.hauptTextActive ? " active" : "")}
                                >
                                    <Row>
                                        <Col className="kslplus-beschreibung-content">
                                            <div className="content" dangerouslySetInnerHTML={{ __html: this.hauptText != null && this.hauptText.text ? this.hauptText.text : "" }}></div>

                                        </Col>
                                    </Row>
                                </Collapse>
                            </Col>

                        </Row>}
                    {this.plantyp === 4 ?
                        <Row>
                            
                            <div className="kslplus-uhconfig-wrapper">
                                <label >Modell:&nbsp;&nbsp;</label>
                                <select className="form-select" onChange={(e) => this.handleUHConfigChange(e)} value={this.state.uhconfig ? this.state.uhconfig.id : 0}>
                                    {configOptions}
                                </select> 
                            </div>
                        </Row> : null}
                    <Row>
                        <Col >
                            <div role="main" className="kslplus-haushaltstab-wrapper-top">
                                <Nav tabs>
                                    <NavItem id={"kslplus-tab-vorberichtvorschau"}>
                                        <NavLink tabIndex={0} active={this.state.activeTab === "1"} onKeyDown={(e) => { if (e.keyCode === 13) this.setState({ activeTab: "1" }); } } onClick={() => this.setState({ activeTab: "1" })} >
                                            <div className="kslplus-reiter-text-hauptzeile">{vbText}</div>
                                        </NavLink>
                                    </NavItem>  
                                    {Utilities.createTTItem(this.settings, "vorberichtvorschau")}
                            
                                    <NavItem id={"kslplus-tab-finanzdatendetailansicht"}>
                                        <NavLink tabIndex={0} active={this.state.activeTab === "2"} onKeyDown={(e) => { if (e.keyCode === 13) this.setState({ activeTab: "2" }); }}  onClick={() => this.setState({ activeTab: "2" })} >
                                            <div className="kslplus-reiter-text-hauptzeile">{detailsText}</div>
                                        </NavLink>
                                    </NavItem>        
                                    {Utilities.createTTItem(this.settings, "finanzdatendetailansicht")}
                                    {this.psVgl.length > 1 && this.psObject?.vergleichbar &&
                                        <NavItem id={"kslplus-tab-vergleich"}>
                                            <NavLink active={this.state.activeTab === "3"} tabIndex={0} onKeyDown={(e) => { if (e.keyCode === 13) this.setState({ activeTab: "3" }); }} onClick={() => this.setState({ activeTab: "3" })} >
                                                <div className="kslplus-reiter-text-hauptzeile">Planvergleich</div>
                                            </NavLink>
                                        </NavItem>        
                                    }
                                </Nav>
                                <TabContent activeTab={this.state.activeTab}>
                                    <TabPane tabId="1">
                                        {this.settings.buchungsart === 1 ?
                                            <Vorbericht kunde={this.kunde} gemeinde={this.gemeinde} jahr={this.jahr} plantyp={this.plantyp} planstufe={this.planstufe} uhconfig={this.state.uhconfig} settings={this.settings} isVisible={this.state.activeTab === "1"} verwaltungsansicht={this.verwaltungsansicht} query={this.props.location?.search} />
                                            :
                                            <VorberichtDoppisch kunde={this.kunde} gemeinde={this.gemeinde} jahr={this.jahr} plantyp={this.plantyp} planstufe={this.planstufe} settings={this.settings} isVisible={this.state.activeTab === "1"} uhconfig={this.state.uhconfig} verwaltungsansicht={this.verwaltungsansicht} query={this.props.location?.search} />
                                        }
    
                                    </TabPane>
                                    <TabPane tabId="2">
                                        {this.settings.buchungsart === 1 ?
                                            <Finanzdaten kunde={this.kunde} gemeinde={this.gemeinde} jahr={this.jahr} plantyp={this.plantyp} planstufe={this.planstufe} settings={this.settings} massnahmen={this.massnahmen} isVisible={this.state.activeTab === "2"} uhconfig={this.state.uhconfig} verwaltungsansicht={this.verwaltungsansicht} query={this.props.location?.search} />
                                        :
                                            <FinanzdatenDoppisch kunde={this.kunde} gemeinde={this.gemeinde} jahr={this.jahr} plantyp={this.plantyp} planstufe={this.planstufe} settings={this.settings} isVisible={this.state.activeTab === "2"} uhconfig={this.state.uhconfig} verwaltungsansicht={this.verwaltungsansicht} query={this.props.location?.search} />
                                        }                                                                                                                                                                
                                    </TabPane>   
                                    <TabPane tabId="3">
                                        {this.psObject?.vergleichbar && this.psVgl.length > 1 && this.settings.buchungsart === 1 &&
                                            <Planvergleich kunde={this.kunde} gemeinde={this.gemeinde} jahr={this.jahr} plantyp={this.plantyp} planstufe={this.planstufe} settings={this.settings} massnahmen={this.massnahmen} isVisible={this.state.activeTab === "3"} psVgl={this.psVgl} verwaltungsansicht={this.verwaltungsansicht} query={this.props.location?.search} />                                            
                                        }
                                        {this.psObject?.vergleichbar && this.psVgl.length > 1 && this.settings.buchungsart === 2 &&
                                            <PlanvergleichDoppisch kunde={this.kunde} gemeinde={this.gemeinde} jahr={this.jahr} plantyp={this.plantyp} planstufe={this.planstufe} settings={this.settings} isVisible={this.state.activeTab === "3"} psVgl={this.psVgl} verwaltungsansicht={this.verwaltungsansicht} query={this.props.location?.search} />
                                        }
                                    </TabPane>   
                                </TabContent>
                            </div>
                        </Col>                        
                    </Row>                    
                </Container>
                <CommentBox header="Kommentar verfassen" labelBetreff="Betreff" labelText="Kommentar" open={this.state.comment} b1="Absenden" onCancel={() => { this.setState({ comment: false }) }} onB1={(b, t) => { this.handleSubmitKommentar(b, t) }} b2="Abbrechen" onB2={() => { this.setState({ comment: false }) }} />
                {this.state.needsLogin4Comment &&
                    <div className="auth-wrapper">
                        <div className="auth-inner">
                            <Login onSubmit={this.handleLogin4Comment} onForgotPW={this.handleForgotPWClick} failed={this.state.logFailed} onCancel={() => this.setState({ needsLogin4Comment: false, logFailed: false}) } />
                        </div>
                    </div>
                }                            
                <MessageBox header="Fehler" text="Sie haben nicht die Berechtigung, um die Planstufe zu kommentieren!" open={this.state.unauthorized4Comment} b1="Schließen" onCancel={() => this.setState({ unauthorized4Comment: false })} onB1={() => this.setState({ unauthorized4Comment: false })} />                
        
            </div>);

    }
}

export default withRouter(App);